import store from '@/Store'

const setupApp = store.state.SetupApp

const detalheExtrato = async (idAutorizacao) => {
  let payload = {
    idAutorizacao
  }
  const response = await setupApp.apiFuncionalidade.detalheExtrato({
    payload: payload,
    loading: true,
    handlerErrorIgnore: [404]
  })
  return response.data
}

const listaAnexos = async (chaveUnica, idAutorizacao) => {
  let payload = {
    chaveUnica,
    idAutorizacao
  }
  const response = await setupApp.apiFuncionalidade.listaAnexos({
    payload: payload,
    loading: true,
    handlerErrorIgnore: [404]
  })
  return response.data
}

const detalheAnexo = async (chaveUnica, idAnexo) => {
  let payload = {
    chaveUnica,
    idAnexo
  }
  const response = await setupApp.apiFuncionalidade.detalheAnexo({
    payload: payload,
    loading: true,
    handlerErrorIgnore: [404]
  })
  return response.data
}

const acionaFuncionalidade = async (req) => {
  const data = {
    type: 'texto',
    message: `${req.data.textoWidget}`
  }
  return { status: true, data, message: 'sucesso' }
}

export {
  detalheExtrato,
  listaAnexos,
  detalheAnexo,
  acionaFuncionalidade
}
